import { MutationTree } from 'vuex';
import { ExportAutomaticState } from './types';
import Vue from 'vue';
import exportAutomatic, { ExportAutomatic, Value } from '@/shared/model/exportAutomatic';

export const mutations: MutationTree<ExportAutomaticState> = {
  setExportAutomatics(state, payload: Value) {
    state.exportAutomatics.items = payload.value.map((x) => exportAutomatic.parse(x));
    state.exportAutomatics.total = payload['@odata.count'] || 0;
    state.exportAutomatics.isLoading = false;
  },
  setExportAutomaticsTotal(state, payload: number) {
    state.exportAutomatics.total = payload;
  },
  setExportAutomaticsIsLoading(state, payload: boolean) {
    state.exportAutomatics.isLoading = payload;
  },
};
